import { useCallback, useEffect, useState } from "react";

export type CrmListViewMode = "table" | "cards";

const STORAGE_KEY = "crm-list-view-mode";
const DEFAULT_MODE: CrmListViewMode = "cards";

function readStoredMode(): CrmListViewMode {
  if (typeof window === "undefined") return DEFAULT_MODE;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === "table" || raw === "cards") return raw;
  } catch {
    // ignore (e.g. private browsing)
  }
  return DEFAULT_MODE;
}

/**
 * Persisted toggle for the CRM list view (data table vs cards).
 * Backed by localStorage under "crm-list-view-mode".
 */
export function useCrmListViewMode(): {
  mode: CrmListViewMode;
  toggleMode: () => void;
} {
  const [mode, setMode] = useState<CrmListViewMode>(readStoredMode);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      // ignore
    }
  }, [mode]);

  const toggleMode = useCallback(() => {
    setMode((prev: CrmListViewMode) => (prev === "table" ? "cards" : "table"));
  }, []);

  return { mode, toggleMode };
}
